
import { granjaApi } from "../../api";
import { useInventariosStore } from "../../store";

import Swal from "sweetalert2";







export const startStockXID = async(id) => {
    try {
        const { data } = await granjaApi.get(`/inventario/xid/${id}`);
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}




export const inventarioXBodega = async({ page, termino, id }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);
        params.append('id',  id);

        const { data } = await granjaApi.get(`/inventario/xbodega/`, { params });
        useInventariosStore.setState({ totalInventario: data.total });
        return data.data;
    } catch (error) {
        Swal.fire('Error', error.response.data.msg, 'error');
        console.log(error);
    }
}  




export const inventarioXBodegaSinPaginar = async(id) => {
    try {
        const { data } = await granjaApi.get(`/inventario/xbodega/todos/${id}`);
        return data.data;
    } catch (error) {
        Swal.fire('Error', error.response.data.msg, 'error');
        console.log(error);
    }
}





export const startSavingIngresarProducto = async(producto) => {
    try {
        await granjaApi.post('/inventario/stock/ingresar', producto);
        Swal.fire('Exitoso', 'Stock Ingresado', 'success');
        return true;
    } catch (error) {
        const msg = error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Ocurrió un error inesperado';
        Swal.fire('Error', msg, 'error');
        return false;
    }
}



export const startTrasladoBodegas = async(stock) => {
    try {
        const { data } = await granjaApi.post('/inventario/stock/traslado', stock);
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const msg = error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Ocurrió un error inesperado';
        Swal.fire('Error', msg, 'error');
        return false;
    }
}

    
